import Swiper, {Pagination} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperPro = new Swiper(".slider-product", {
    modules: [Pagination],
    slidesPerView: 1, 
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.product-pagination',
      clickable: true,
    }
   
  });
}
  
